export interface IEICFTemplate {
    id: number;
    healthcareFacilityID: number;
    code: string;
    version: number;
    status: string; // "Draft" | "Approved"
    nameEn: string;
    nameFr: string;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    rawJson: string;
    themeJson?: string | null;
    kind: string; // "SurveyJson" | "FillablePdf"
    documentS3Key?: string | null;
    fieldConfigJson?: string | null;
    approvedDate?: string | null;
    approvedByUserID?: number | null;
    createdDate: string;
    lastModifiedDate: string;
    canEdit: boolean;
    canApprove: boolean;
}

export interface IEICFTemplateInput {
    healthcareFacilityID: number;
    code: string;
    nameEn: string;
    nameFr: string;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    rawJson: string;
    themeJson?: string | null;
    kind?: string; // defaults to "SurveyJson" server-side
    documentS3Key?: string | null;
    fieldConfigJson?: string | null;
}

export interface IEICFFacilityAssignmentRequest {
    healthcareFacilityID: number;
    eicfTemplateID: number;
}

export const EICFTemplateStatus = {
    Draft: 'Draft',
    Approved: 'Approved',
} as const;

export const EICFTemplateKind = {
    SurveyJson: 'SurveyJson',
    FillablePdf: 'FillablePdf',
} as const;

export interface IEICFEscalationConfig {
    initialNotifyByEmail: boolean;
    initialNotifyBySMS: boolean;
    initialHcpIds: number[];
    level1Enabled: boolean;
    level1DelayMinutes: number | null;
    level1NotifyByEmail: boolean;
    level1NotifyBySMS: boolean;
    level1HcpIds: number[];
    level2Enabled: boolean;
    level2DelayMinutes: number | null;
    level2NotifyByEmail: boolean;
    level2NotifyBySMS: boolean;
    level2HcpIds: number[];
}
